import Event from "./event.js";
import bus from "./bus.js";
import custom from "./custom.js";
import { version } from "../package.json";

const unifold = globalThis.unifold || (globalThis.unifold = new Map());

Object.defineProperties(unifold, {
    version: {
        value: version,
        enumerable: true,
    },
    Event: {
        value: Event,
        enumerable: true,
    },
    activate: {
        value: bus.activate.bind(bus),
        enumerable: true,
    },
    set: {
        value: custom.set.bind(custom),
        enumerable: true,
    },
    unset: {
        value: custom.delete.bind(custom),
        enumerable: true,
    },
});

unifold.forEach((value, key) => {
    unifold.set(key, value);
    unifold.delete(key);
});

export default unifold;
